export default __webpack_public_path__ + "e503ce740d9ffd95d0f188913be05d0c.png";